import { CustomElement, getHtmlFromUrl } from '@/utils';

export default class Search extends CustomElement {
  static component = 'b-search';
  form: HTMLFormElement | null = null;
  results: HTMLDivElement | null = null;

  init() {
    this.form = this.$('form');
    this.results = this.$('results');

    if (this.form) {
      const field = this.form.querySelector<HTMLInputElement>('input[name="query"]');
      if (field) {
        field.focus();
      }
    }

    this.form?.addEventListener('submit', (e) => {
      e.preventDefault();
      const data = new FormData(this.form);
      const search = new URLSearchParams(data as any);
      getHtmlFromUrl(this.form.action+'?'+search.toString(), '[data-el="results"]').then((html) => {
        if (html && this.results) {
          this.results.innerHTML = html.innerHTML;
        }
        const url = new URL(this.form.action);
        url.searchParams.set('query', search.get('query'));
        window.history.pushState({}, '', url.href);
      });

      this.results?.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
}
